// src/App.jsx
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from "react-router-dom";

import { AuthProvider } from "./context/authContext";
import { ImagesProvider } from "./context/imagesContext";

import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";
import ProtectedLayout from "./layouts/ProtectedLayout";
import News from "./pages/news/News";
import Events from "./pages/Events";
import Profile from "./pages/Profile";
import Companies from "./pages/Companies";
import NotFound from "./pages/NotFound";
import NewsForms from "./pages/news/NewsForm";
import Services from "./pages/Services";
import MyServices from "./pages/MyServices";
import AdminNewsRequests from "./pages/admin/AdminNewsRequests";
import Agreement from "./pages/Agreements";
import NewsDetails from "./pages/news/NewsDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import ResetPassword from "./pages/password/ResetPassword";
import PaymentResult from "./pages/PaymentResult";

// Documentación oficial
import AnnualReports from "./pages/Menu/Administration/Annualreport";
import XDashboard from "./pages/Menu/Cascade-menu";
import MembershipApplicationsSection from "./pages/Menu/Vinculation/panel/MembershipApplicationsSection";
import MembershipConfigPage from "./pages/Menu/Administration/MembershipConfigPage";
import StatutesPage from "./pages/Menu/Administration/Statutes";
import EthicsCodePage from "./pages/Menu/Administration/EthicsCodePage";
import CrimePreventionPage from "./pages/Menu/Administration/PreventionModel";
import ProtocolsPage from "./pages/Menu/Administration/Protocols";
import InternalRegulationPage from "./pages/Menu/Administration/Internalregulations";
import MaterialsPage from "./pages/Menu/Administration/Material-Content";
import PopupsAdminPage from "./pages/Menu/Administration/PopupsAdminPage";
import AdminChatbot from "./pages/admin/AdminChatbot";
import ChatbotButton from "./components/chatbot/ChatbotButton";
import DownloadApp from "./pages/DownloadApp";

// Membership públicas
import MembershipApply from "./pages/MembershipApply";


// Scroll to top
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// Shell público (sin providers)
function PublicShell() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}

// Shell privado (con providers)
function PrivateShell() {
  return (
    <AuthProvider>
      <ImagesProvider>
        <ScrollToTop />
        <Outlet />
        <ChatbotButton />
      </ImagesProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* === Rama PÚBLICA sin providers === */}
        <Route element={<PublicShell />}>
          <Route path="/membership/apply" element={<MembershipApply />} />
        </Route>

        {/* === Rama PRIVADA con providers === */}
        <Route element={<PrivateShell />}>
          {/* Públicas “normales” dentro del árbol privado */}
          <Route path="/" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protegidas con layout */}
          <Route element={<ProtectedLayout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/events" element={<Events />} />
            <Route path="/news-form" element={<NewsForms />} />
            <Route path="/agreements" element={<Agreement />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/news/:id" element={<NewsDetails />} />
            <Route path="/services" element={<Services />} />
            <Route path="/my-services" element={<MyServices />} />
            <Route path="/payment-result" element={<PaymentResult />} />
            <Route path="/payment-result/:buyOrder" element={<PaymentResult />} />

            {/* Reporte anual (autenticados) */}
            <Route path="/annual-reports" element={<AnnualReports />} />
            <Route path="/statutes" element={<StatutesPage />} />
            <Route path="/ethics-code" element={<EthicsCodePage />} />
            <Route path="/crime-prevention" element={<CrimePreventionPage />} />
            <Route path="/protocols" element={<ProtocolsPage />} />
            <Route path="/internal-regulation" element={<InternalRegulationPage />} />
            <Route path="/material-content" element={<MaterialsPage />} />
            <Route path="/download-app" element={<DownloadApp />} />

            {/* Solo ADMIN */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/panel/*" element={<XDashboard />} />
              <Route path="/admin/news-requests" element={<AdminNewsRequests />} />
              <Route path="/admin/popups" element={<PopupsAdminPage />} />
              <Route path="/admin/chatbot" element={<AdminChatbot />} />
              <Route path="/admin/membership-config" element={<MembershipConfigPage />} />
              <Route
                path="/admin/membership-applications"
                element={<MembershipApplicationsSection onClose={() => window.history.back()} />}
              />
            </Route>
          </Route>
        </Route>

        {/* 404 global */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}


